import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Job & Project Module Service Stores
 *
 * In Premier, a "job" IS a `projects` row: the Job Management screen
 * (/admin/job-management, src/views/admin/CreateJob) reads `rootStore.projectsStore`,
 * and a project carries `id` (numeric PK), `projectNumber` ("25-001") and
 * `projectName`. There is no separate `jobs` service on the API.
 *
 * The `projects` service store is therefore ALREADY registered under
 * `projectStores` (see ./project.stores.ts) and derives `rootStore.projectsStore`
 * via `uriToCamel("projects") + "Store"`. Because main.tsx feeds the same
 * `serviceStores` array into BOTH injectStores registries (the host's and
 * @intrasync/react's, which the @intrasync/accounting module reads), the
 * accounting module can inject `projectsStore` directly as its host "jobs" store.
 *
 * We intentionally do NOT re-register `projects` here: a duplicate config would
 * mount a second socket-backed ServiceStore for the same service path (double
 * realtime listeners, redundant fetches) with no benefit. The accounting module
 * maps `projects` entities to its `{ id, name }` JobRef using the project PK as
 * the job id, so a saved `jobId` references the Premier job directly — no copy/sync.
 */
export const jobStores: ServiceStoreConfig[] = [
  // Premier jobs == `projects`, already registered in ./project.stores.ts
  // (-> rootStore.projectsStore). No separate job service store is needed.
];
